import { render, staticRenderFns } from "./PreviewLayout.vue?vue&type=template&id=33740c23&scoped=true"
import script from "./PreviewLayout.vue?vue&type=script&lang=js"
export * from "./PreviewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33740c23",
  null
  
)

export default component.exports